import {ORDER_STATUS} from 'src/data/enums/order';
import {FilterAutoCompleteOptions} from 'src/view/components/filters/AutoComplete/AutoComplete';

export const orderStatusOptions: FilterAutoCompleteOptions = Object.keys(ORDER_STATUS).map(
    (key) => ({
        value: key,
        label: key,
    })
);
